import {base} from './environment.base';
import {Environment} from './environment.model';

export const environment: Environment = {
  ...base,
  name: 'dev',
  apiBaseUrl: '',
  sentryDataSourceName: 'https://5830209d0f4b4f24129e7cbd51b7b74e@sentry.swehq.com/28',
  YBugProjectId: '86t16k0ys69jvwz7ctsy',
};
